// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD5vrg-LksrJcxrkSOvn9vmjF64vPsNuwo",
  authDomain: "fahimferdous-4ff2b.firebaseapp.com",
  projectId: "fahimferdous-4ff2b",
  storageBucket: "fahimferdous-4ff2b.firebasestorage.app",
  messagingSenderId: "183039117483",
  appId: "1:183039117483:web:c62d6838533dbb547f8fee",
  measurementId: "G-NEYWRM09MF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
